<template>
    <div id="vue-app">
        <router-view/>
    </div>
</template>

<script>
    import { ThemeSettingsHelper } from "@/mixins/themeSettings";

    export default {
        beforeCreate() {
            ThemeSettingsHelper.checkLocalStorageForHorseBreed();
        },
    };
</script>

<style lang="scss">
</style>
